module.exports = __webpack_public_path__ + "img/background-landing@2x.fe70269e.jpg";